import React from 'react'
import StoreForm from '../../components/Stores/StoreForm'

const UpdateStore = () => {
  return (
    <StoreForm mode="Update"/>
  )
}

export default UpdateStore